import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FormControl, InputLabel, Select, MenuItem, Grid, Card, CardContent, CardActions, Button, Typography, Box } from '@mui/material';
import ContentContainer from "../../component/ContentContainer";

const Report = () => {
    const [selectedFormat, setSelectedFormat] = useState('pdf');
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);

    const ApiUrl = `${process.env.REACT_APP_BACKEND_LINK}/api`;

    const fetchReports = async () => {
        try {
            const response = await axios.get(`${ApiUrl}/reports/list`);
            setReports(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao buscar relatórios:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReports();
    }, []);

    const handleFormatChange = (event) => {
        setSelectedFormat(event.target.value);
    };

    const generateReport = async (reportType) => {
        try {
            const response = await axios.get(`${ApiUrl}/reports/export`, {
                params: {
                    filename: reportType,
                    format: selectedFormat
                },
                responseType: 'blob'
            });
            console.log(response.data)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${reportType}.${selectedFormat}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Erro ao gerar relatório:', error);
        }
    };

    if (loading) {
        return <Typography variant="h6">Carregando relatórios...</Typography>;
    }

    return (
        <ContentContainer width={'xl'}>
            <Typography variant="h4" gutterBottom>Gerar Relatórios</Typography>
            <FormControl fullWidth margin="normal" variant="outlined">
                <InputLabel>Formato do Relatório</InputLabel>
                <Select value={selectedFormat} onChange={handleFormatChange} label="Formato do Relatório">
                    <MenuItem value="pdf">PDF</MenuItem>
                    <MenuItem value="excel">Excel</MenuItem>
                    <MenuItem value="csv">CSV</MenuItem>
                </Select>
            </FormControl>

            <Grid container spacing={3} mt={2}>
                {reports.map((report, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card>
                            <Box style={{ backgroundColor: report.color, padding: '8px' }}>
                            </Box>
                            <Box style={{ padding: '8px', paddingLeft: '14px', paddingBottom: '2px' }}>
                                <Typography variant="h6" component="div">
                                    {report.viewValue}
                                </Typography>
                            </Box>
                            <CardContent>
                                <Typography variant="body2" color="text.secondary">{report.description}</Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary" onClick={() => generateReport(report.value)}>Gerar Relatório</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </ContentContainer>
    );
};

export default Report;
